/**
 * Language-code mapping that carries no dependency of its own. `@/utils/localization` reads the
 * initialised i18next instance, so anything i18next itself loads cannot import from there without
 * closing a cycle — this module stays importable from either side.
 */

/** Maps the `fr_FR` app language code to the base `fr` used for content keys. */
export const normalizeFrenchLanguageCode = (languageCode: string): string =>
    languageCode === 'fr_FR' ? 'fr' : languageCode;
